import { Component, TemplateFunction } from '@ribajs/core'

import { SbSubCollectionComponent } from './sb-sub-collection.component.js'
import { SbSubBlogComponent } from './sb-sub-blog.component.js'

/**
 * A container for sub collections and blogs
 */
export class SbSubContainerComponent extends Component {
  public static tagName = 'sb-sub-container'

  public subComponents: (SbSubCollectionComponent | SbSubBlogComponent)[] = []

  static get observedAttributes(): string[] {
    return []
  }

  protected requiredAttributes(): string[] {
    return []
  }

  public scope = {}

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbSubContainerComponent.observedAttributes)
    // Restore the first sub component if the component is already bound
    if (this._bound && this.subComponents.length > 0) {
      this.restoreFirstSubComponent()
    }
  }

  protected restoreFirstSubComponent() {
    const firstSubComponent = this.subComponents[0]
    if (firstSubComponent) {
      firstSubComponent.load()
    }
  }

  protected async afterBind() {
    await super.afterBind()
    this.subComponents = Array.from(
      this.querySelectorAll(
        `${SbSubCollectionComponent.tagName}, ${SbSubBlogComponent.tagName}`,
      ),
    ) as (SbSubCollectionComponent | SbSubBlogComponent)[]
    this.classList.add(`${SbSubContainerComponent.tagName}-ready`)
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
